"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalConsent = void 0;
var React = require("react");
var react_router_1 = require("react-router");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
//import { loadGapiInsideDOM, loadAuth2 } from 'gapi-script';
var msal_react_1 = require("@azure/msal-react");
var google_1 = require("@react-oauth/google");
var ExternalConsent = /** @class */ (function (_super) {
    __extends(ExternalConsent, _super);
    function ExternalConsent(props) {
        var _this = _super.call(this, props) || this;
        _this.onLegalNoticeClicked = function (ev, checked) {
            _this.setState({ legalNoticeChecked: checked });
        };
        _this.onPrivacyNoticeClicked = function (ev, checked) {
            _this.setState({ privacyNoticeChecked: checked });
        };
        _this.onConfirmClicked = function () {
            console.log("MSAL Context", _this.context);
            _this.setState({ showWaitingSpinner: true });
            window.sessionStorage.removeItem("rsmConsentTarget");
            _this.props.loginComponent.ensureSPUser(_this.state.user, _this.state.user.bearerToken.token, true).then(function (finalUser) {
                window.sessionStorage.authToken = JSON.stringify(finalUser.bearerToken);
                window.sessionStorage.rsmUser = JSON.stringify(finalUser);
                _this.props.setAuthStatus(true, finalUser);
                _this.setState({ redirectWelcome: true, showWaitingSpinner: false });
            }).catch(function (err) {
                var error = err;
                if (err.message) {
                    error = err.message;
                }
                alert("Error: " + error);
            });
        };
        _this.onNoConsentClicked = function () {
            var _a, _b;
            var that = _this;
            // sign out of google, if it's a google account
            try {
                //loadGapiInsideDOM().then((gapi) => {
                //    console.log("Gapi loaded....", gapi);
                //    gapi.load("auth2", function () {
                //        console.log("auth2 loaded", (window as any).gapi.auth2);
                //        gapi.auth2.getAuthInstance().then((auth2: any) => {
                //            auth2.signOut().then(() => {
                //                console.log("signed out.");
                //                that.setState({ redirectWelcome: true });
                //            });
                //        });
                //    });
                //});
                google_1.googleLogout();
                that.setState({ redirectWelcome: true });
            }
            catch (err) { /* ignore possible errors */ }
            // sign out of microsoft, if it's a microsoft account
            try {
                (_b = (_a = _this.context) === null || _a === void 0 ? void 0 : _a.instance) === null || _b === void 0 ? void 0 : _b.logoutRedirect({
                    onRedirectNavigate: function (url) {
                        // Return false if you would like to stop navigation after local logout
                        return false;
                    }
                });
            }
            catch (err) { /* ignore possible errors*/ }
            window.sessionStorage.removeItem("rsmConsentTarget");
        };
        _this.state = {
            legalNoticeChecked: false,
            privacyNoticeChecked: false,
            redirectWelcome: false,
            user: null,
            showWaitingSpinner: false
        };
        return _this;
    }
    ExternalConsent.prototype.componentDidMount = function () {
        var _a;
        this.setState({
            user: JSON.parse((_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.rsmConsentTarget)
        });
    };
    ExternalConsent.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (React.createElement("div", null,
            this.state.redirectWelcome && React.createElement(react_router_1.Redirect, { to: "/" }),
            React.createElement("div", null,
                "Hello ", (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 :
                _b.firstName,
                " ", (_d = (_c = this.state) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 :
                _d.lastName,
                ",",
                React.createElement("br", null),
                React.createElement("br", null),
                "This is the first time you are accessing the Straumann Research Screening Site with your ", (_f = (_e = this.state) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 :
                _f.accountType,
                " account.",
                React.createElement("br", null),
                "In order to be able to access this site we need the following consent from you."),
            React.createElement(office_ui_fabric_react_1.Stack, null,
                React.createElement(office_ui_fabric_react_1.Stack, { style: { marginTop: '15px' } },
                    React.createElement(office_ui_fabric_react_1.Stack, { horizontal: true, verticalAlign: 'center' },
                        React.createElement(office_ui_fabric_react_1.Checkbox, { id: "chkLegal", onChange: this.onLegalNoticeClicked, checked: (_g = this.state) === null || _g === void 0 ? void 0 : _g.legalNoticeChecked }),
                        React.createElement(office_ui_fabric_react_1.Label, { htmlFor: "chkLegal", style: { position: 'relative', top: '-5px' } },
                            "I agree to the ",
                            React.createElement("a", { target: "_blank", href: "https://www.straumann.com/en/dental-professionals/legal-notice.html" }, "StraumannGroup's Legal Notice")))),
                React.createElement(office_ui_fabric_react_1.Stack, null,
                    React.createElement(office_ui_fabric_react_1.Stack, { horizontal: true, verticalAlign: 'center' },
                        React.createElement(office_ui_fabric_react_1.Checkbox, { id: "chkPrivacy", onChange: this.onPrivacyNoticeClicked, checked: (_h = this.state) === null || _h === void 0 ? void 0 : _h.privacyNoticeChecked }),
                        React.createElement(office_ui_fabric_react_1.Label, { htmlFor: "chkPrivacy", style: { position: 'relative', top: '-5px' } },
                            "I acknowledge that my data will be processed in accordance with the ",
                            React.createElement("a", { target: "_blank", href: "https://www.straumann.com/group/en/discover/privacy/com/en.html" }, "StraumannGroup's Privacy Notice")))),
                React.createElement(office_ui_fabric_react_1.Stack, { style: { marginTop: '20px' } },
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                        React.createElement(office_ui_fabric_react_1.DefaultButton, { style: { color: 'white', backgroundColor: !(this.state.legalNoticeChecked && this.state.privacyNoticeChecked) ? 'gray' : 'green', cursor: !(this.state.legalNoticeChecked && this.state.privacyNoticeChecked) ? 'not-allowed' : 'pointer' }, text: "Confirm", onClick: this.onConfirmClicked, disabled: !(this.state.legalNoticeChecked && this.state.privacyNoticeChecked) }),
                        React.createElement(office_ui_fabric_react_1.DefaultButton, { style: { color: 'white', backgroundColor: 'red' }, text: "I do not Consent", onClick: this.onNoConsentClicked })))),
            React.createElement(office_ui_fabric_react_1.Dialog, { hidden: !this.state.showWaitingSpinner, dialogContentProps: {
                    type: office_ui_fabric_react_1.DialogType.normal,
                }, modalProps: { isBlocking: true, className: "busyOverlay" } },
                React.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.large, label: "Working on it...", ariaLive: "assertive" }))));
    };
    ExternalConsent.contextType = msal_react_1.MsalContext;
    return ExternalConsent;
}(React.Component));
exports.ExternalConsent = ExternalConsent;
//# sourceMappingURL=ExternalConsent.js.map